import ConsultationForm from "./Components/ConsultationForm.jsx"

const ConsultationPage = () => {
  return <ConsultationForm />;
};

export default ConsultationPage;
